import { render, staticRenderFns } from "./ResultBreakdown.vue?vue&type=template&id=824944c4&"
import script from "./ResultBreakdown.vue?vue&type=script&lang=js&"
export * from "./ResultBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./ResultBreakdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports